import React, { Component } from "react";
import "./index.scss";
import Portal from "./Portal";

export default class LimiterPopup extends Component {

	bgClose = (e) => {
		if (e.target === document.querySelector('.bg-popup')) {
			const { closePopup } = this.props;
			closePopup();
		}
	};

	render() {
		const { limit, isLogged, closePopup, isOpened } = this.props;

		if (limit == null || !limit.hasOwnProperty('used')) {
			return <></>;
		}

		if (limit.used !== limit.allowed) {
			return <></>;
		}

		return <Portal><div className="idg-limiter-popup">
			<div className='bg-popup' style={{ display: 'none' }} onClick={this.bgClose}>
				<span className="helper"></span>
				<div id="popup-content" className={(isOpened) ? 'animated fadeInUp' : 'hideme animated fadeOutUp'}>
					<div className="popupCloseButton" onClick={closePopup}></div>
					<div className="popup-wrap">
						{isLogged ? <>
							<div className="popup-content-left">
								<h5>Daily limit reached</h5>
								<p>You have used {limit.used} out of {limit.allowed} daily searches. Your daily allowance will reset at 12 am GMT (7pm ET).</p>
								<a href="https://tools.brightlocal.com/seo-tools/admin/login" target="_blank" rel="noopener noreferrer" className="button green">Go to your account</a>
							</div>
							<div className="popup-content-right">
								<h6 className="bold">Visit your dashboard now to explore the entire BrightLocal platform, including: </h6>
								
								<div class="products">
									<div class="item">
										<div class="item-content">
											<img src={`${(window.wpApiSettings && window.wpApiSettings.pluginUrl) || '/wp-content/plugins/wp-id-generator/'}frontend/build/img/icons/explore_local_rank_tracking.svg`} alt="Track Local Rankings" />
											<span>Track Local Rankings</span>
										</div>
									</div>
									<div class="item">
										<div class="item-content">
											<img src={`${(window.wpApiSettings && window.wpApiSettings.pluginUrl) || '/wp-content/plugins/wp-id-generator/'}frontend/build/img/icons/explore_local_seo_auditing.svg`} alt="Audit Local SEO" />
											<span>Audit Local SEO</span>
										</div>
									</div>
									<div class="item">
										<div class="item-content">
											<img src={`${(window.wpApiSettings && window.wpApiSettings.pluginUrl) || '/wp-content/plugins/wp-id-generator/'}frontend/build/img/icons/explore_listings_management.svg`} alt="Listings Management" />
											<span>Listings Management</span>
										</div>
									</div>
									<div class="item">
										<div class="item-content">
											<img src={`${(window.wpApiSettings && window.wpApiSettings.pluginUrl) || '/wp-content/plugins/wp-id-generator/'}frontend/build/img/icons/explore_review_management.svg`} alt="Review Managementr" />
											<span>Review Management</span>
										</div>
									</div>
								</div>
							</div>
						</> : <>
							<div className="popup-content-left">
								<h5>Daily limit reached</h5>
								<p>You’ve been busy! Unfortunately, you’ve hit your daily limit for free searches.</p>
								<p>Don’t worry, just <a href={'https://tools.brightlocal.com/seo-tools/admin/login?return_to=' + window.location.href} target="_blank" rel="noopener noreferrer" >log in</a> or <a href="https://app.brightlocal.com/auth/sign-up/257" target="_blank" rel="noopener noreferrer" >sign up</a> to BrightLocal for access to more daily searches.
								</p>

								<a className="button green" href="https://app.brightlocal.com/auth/sign-up/257" target="_blank" rel="noopener noreferrer" >14 day free trial<sub>No Card Needed</sub></a>
								<p className="sub-button">Already have an account? <a href={'https://tools.brightlocal.com/seo-tools/admin/login?return_to=' + window.location.href} target="_blank" rel="noopener noreferrer" >Log in</a>
								</p>
							</div>
							<div className="popup-content-right">
								<h6 className="bold">By signing up, you’ll get:</h6>
								<ul>
									<li>Increased access to all of our free tools</li>
									<li>Access to the entire BrightLocal platform, including:</li>
								</ul>
								<div class="products">
									<div class="item">
										<div class="item-content">
											<img src={`${(window.wpApiSettings && window.wpApiSettings.pluginUrl) || '/wp-content/plugins/wp-id-generator/'}frontend/build/img/icons/explore_local_rank_tracking.svg`} alt="Track Local Rankings" />
											<span>Track Local Rankings</span>
										</div>
									</div>
									<div class="item">
										<div class="item-content">
											<img src={`${(window.wpApiSettings && window.wpApiSettings.pluginUrl) || '/wp-content/plugins/wp-id-generator/'}frontend/build/img/icons/explore_local_seo_auditing.svg`} alt="Audit Local SEO" />
											<span>Audit Local SEO</span>
										</div>
									</div>
									<div class="item">
										<div class="item-content">
											<img src={`${(window.wpApiSettings && window.wpApiSettings.pluginUrl) || '/wp-content/plugins/wp-id-generator/'}frontend/build/img/icons/explore_listings_management.svg`} alt="Listings Management" />
											<span>Listings Management</span>
										</div>
									</div>
									<div class="item">
										<div class="item-content">
											<img src={`${(window.wpApiSettings && window.wpApiSettings.pluginUrl) || '/wp-content/plugins/wp-id-generator/'}frontend/build/img/icons/explore_review_management.svg`} alt="Review Management" />
											<span>Review Management</span>
										</div>
									</div>
								</div>
							</div>
						</>}
					</div>
				</div>
			</div>
		</div></Portal>;
	}
}
